import { PERMISSIONS } from '@/permissions/permissions.catalog';
import { usePermissions } from '@/permissions/usePermissions';
import { useAuth } from '@/store/auth/auth.store';
import { hasAnyRole, isInOwnerGroup, OWNER_GROUP_ROLES, UserRole } from '@/utils/roles';

const INVITE_RUNNERS: readonly UserRole[] = [...OWNER_GROUP_ROLES, UserRole.CAPTAIN];

/**
 * Who may send guest invitations and handle the ones already sent. Inviting takes the InviteUser
 * permission (the owner group always has it). Withdrawing an invitation, sending it again or moving
 * its deadline also takes the owner group or a captain, unless the viewer sent it themselves.
 */
export const useInviteRights = () => {
  const { can } = usePermissions();
  const userId = useAuth((state) => state.session?.id);
  const userRoles = useAuth((state) => state.session?.userRoles);

  const canInvite = can(PERMISSIONS.users.InviteUser) || isInOwnerGroup(userRoles);
  const runsInvites = hasAnyRole(userRoles, INVITE_RUNNERS);

  return {
    canInvite,
    canManage: (creatorId?: string) =>
      canInvite && (runsInvites || (!!creatorId && creatorId === userId)),
  };
};
